import { colorsText } from '@/helpers';
import { formatNumber } from '@/utils/helpers';
import { ICellRendererParams } from 'ag-grid-community';

const PointByVendorEdit = (params: ICellRendererParams) => {
  return (
    <>
      <p style={{ color: colorsText(params.colDef?.colId) }} className="statisticVendorEdit-center">
        {params.value && formatNumber(Number(params.value) || 0)}
      </p>
    </>
  );
};
export default PointByVendorEdit;
